export function calculatePrintDimensions({
  artworkAspectRatio,
  requestedWidthInches,
  maxWidthInches,
  maxHeightInches,
  heightIsEstimate = false
}) {
  const values = [
    artworkAspectRatio,
    requestedWidthInches,
    maxWidthInches,
    maxHeightInches
  ];

  const inputsValid = values.every(
    (value) => Number.isFinite(value) && value > 0
  );

  if (!inputsValid) {
    return {
      widthInches: requestedWidthInches,
      heightInches: null,
      fitsWidth: false,
      fitsHeight: false,
      isValid: false,
      heightIsEstimate
    };
  }

  const heightInches = requestedWidthInches / artworkAspectRatio;
  const fitsWidth = requestedWidthInches <= maxWidthInches;
  const fitsHeight = heightInches <= maxHeightInches;

  return {
    widthInches: requestedWidthInches,
    heightInches,
    fitsWidth,
    fitsHeight,
    isValid: fitsWidth && fitsHeight,
    heightIsEstimate
  };
}